export default function () {
  return {
    isSavingTreatmentAbroad: false,
  };
}
